var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "m13.59 6.411-5.5 3.819-5.753-1.918a.98.98 0 0 1 .009-1.862l14.708-4.736a.98.98 0 0 1 1.232 1.233L13.55 17.655a.98.98 0 0 1-1.861.009l-1.927-5.78z",
    clipRule: "evenodd"
  })));
};
export default SvgSend;